import React, { useEffect, useRef, useState } from "react";
// import { marked } from "marked";
import svgSortAsc from "../../svgs/arrow-up.svg";
import Icon from "../Icon";
import { CREATE_OR_UPDATE_EVENT, GET_EVENT_QUERY } from "../Graphql/Queries/EventsQuery";
import { fetchData, mutateData } from "../Service/graphQlService";
import { browserHistory } from "react-router";
import { uploadFile } from "../../requests/fileRequests";
import Alert from "../Alert/Alert";
import { formatDateToMMDDYYYY, getIsoDate } from "../../utils";


const Event = (props) => {
  const [title, setTitle] = useState();
  const [text, setText] = useState();
  const [date, setDate] = useState(); // New date state
  const [deleted, setDeleted] = useState();
  const [original, setOriginal] = useState({ title: "", text: "", date: "", deleted: null });
  const [edit, setEdit] = useState(!props.edit || false);
  const [isBusy, setIsBusy] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const fileInputRef = useRef();
  const id = props.params.id || false;

  useEffect(() => {
    if (id) {
      fetchData(GET_EVENT_QUERY, { arcimedesRowId: parseInt(id) })
        .then((res) => {
          setTitle(res.data.getEvent.title);
          setText(res.data.getEvent.text);
          setDate(formatDateToMMDDYYYY(res.data.getEvent.date));
          setDeleted(res.data.getEvent.deleted);
          setOriginal({
            title: res.data.getEvent.title,
            text: res.data.getEvent.text,
            date: formatDateToMMDDYYYY(res.data.getEvent.date),
            deleted: res.data.getEvent.deleted,
          });
        })
        .catch((error) => console.error("Error fetching event:", error));
    }
  }, [id]);

  const getBase64 = (file) => {
    return new Promise(resolve => {
        let baseURL = "";
        let reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = () => {
            baseURL = reader.result;
            resolve(baseURL);
        };
    });
}

  const handleImageUpload = (event) => {
    setIsBusy(true);
    let selectedFile = event.currentTarget.files[0];
    const fileSize = selectedFile.size / 1000000; //mb

    if (fileSize > 20){
        setError('Maximum file size exceeded');
        setIsBusy(false);
        return;
    }
    
    getBase64(selectedFile).then(result => {
        selectedFile["base64"] = result;
        setError(null);
        const fileName = selectedFile.name
        const mimeType = selectedFile.type       // e.g. "image/png" or "application/pdf"
        const ext = fileName.split('.').pop().toLowerCase()

        // decide the type param
        let type
        if (mimeType.startsWith('image/')) {
          type = 'image'
        } else if (mimeType === 'application/pdf' || ext === 'pdf') {
          type = 'pdf'
        } else { 
          setError("Unsupported file type. Only images and PDFs are allowed.");
          setIsBusy(false);
          return;
        }
        uploadFile({fileName, base64File: result, folder:'website/events',type}).then(res => {
                    res = res.data.uploadImage;
                    if (!res || !res.success) {  
                      setError(
                        res && res.message ? res.message : "Unspecified error",
                      );
                    } else {
                        const path = res.fileUrl &&  res.fileUrl.fileUrl ? res.fileUrl.fileUrl.split('?')[0] : null
                        if (path) {
                            const markdownImage = `${type == 'image' ? '![Image ':'['}description](${path})\n`;
                            setText((prev) => prev + "\n" + markdownImage);
                        } else {
                            setError("Failed to upload image.");
                        }
                       
                    }
                }).finally(()=>{
                  setIsBusy(false);
                })
    })
}

  const toggleEdit = () => {
    setEdit(!edit);
  };

  const cancelEditorChanges = () => {
    if (!props.edit) {
      history.back();
      return;
    }
    setTitle(original.title);
    setText(original.text);
    setDate(original.date); // Reset the date
    setDeleted(original.deleted);
    setEdit(false);
  };


  const handleDelete = async () => {
    if(deleted === null){
      saveEditorContent(1);
    }else{
      saveEditorContent();
    }
  };


  const saveEditorContent = async (deleted = null) => {
    setIsBusy(true);
    setError("");
    setSuccess(false);
    try {
      if (!title || !text || !date) {
        setError("Title, text, and date cannot be empty.");
        return;
      }
      const input = {
        title,
        text,
        date: getIsoDate(date),
        deleted: deleted,
      };
      if (id) {
        input.arcimedes_row_id = parseInt(id);
      }
      const res = await mutateData(CREATE_OR_UPDATE_EVENT, { input });
      if (res && res.data.createOrUpdateEvent.success) {
        setTitle(res.data.createOrUpdateEvent.event.title);
        setText(res.data.createOrUpdateEvent.event.text);
        setDate(formatDateToMMDDYYYY(res.data.createOrUpdateEvent.event.date)); // Update the date
        setDeleted(res.data.createOrUpdateEvent.event.deleted);
        setOriginal({
          title: res.data.createOrUpdateEvent.event.title,
          text: res.data.createOrUpdateEvent.event.text,
          date: formatDateToMMDDYYYY(res.data.createOrUpdateEvent.event.date),
          deleted: res.data.createOrUpdateEvent.event.deleted,
        });
        if (!id && !props.edit) {
          browserHistory.push({
            pathname: `/event/${res.data.createOrUpdateEvent.event.arcimedes_row_id}`,
          });
        }
        setSuccess("Saved");
      } else {
        setError("Failed to save changes.");
      }
    } catch (err) {
      setError("Failed to save changes.");
      console.log(err)
    } finally {
      setIsBusy(false);
      setEdit(false);
    }
  };

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 5000);
  
      return () => clearTimeout(timer);
    }
  }, [success]);

  return (
    <div className="ContentPage">
      <div className="page-rounded-corner-container">
        <div className="page-header-container">
          <div
            className="page-back-button"
            onClick={() => {
              history.back();
            }}
          >
            <Icon svg={svgSortAsc} />
            Events
          </div>
          <div className="page-header">
            <div className="page-title">
              {title && props.edit ? title.length > 16 ? `${title.substring(0, 16)}...`: title  : !props.edit ? "Add Event" : "Event Title"}
            </div>
            {!edit && <div className="button-new negative" onClick={handleDelete}>
                  {deleted == null ? 'Delete': 'Undelete'}
                </div>}
            {edit && (
              <React.Fragment>
                <div className="button-new negative" onClick={cancelEditorChanges}>
                  Cancel
                </div>
                <div
                  className="button-new positive"
                  onClick={()=>!isBusy ? saveEditorContent() : null} // Prevent multiple clicks while busy
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  {isBusy ? (
                    <div
                      style={{
                        width: "16px",
                        height: "16px",
                        border: "2px solid transparent",
                        borderTop: "2px solid #fff",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                      }}
                    />
                  ) : props.edit ? (
                    "Save"
                  ) : (
                    "Add"
                  )}
                </div>
              </React.Fragment>
            )}
            {!edit && (
              <div className="button-new positive" onClick={toggleEdit}>
                Edit
              </div>
            )}
          </div>
          {success ? <Alert type="success">{success}</Alert> : null}
          {error ? <Alert type="error">{error}</Alert> : null}
          <div className="line" />
        </div>
      </div>
      <div className="page-body-container">
        <label>
          Title:
          <br />
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            style={{ width: "100%", marginBottom: "1rem" }}
            disabled={!edit}
          />
        </label>
        <br />
        <label>
          Content:
          <br />
          <textarea
            rows={15}
            value={text}
            onChange={(e) => setText(e.target.value)}
            style={{ width: "100%" }}
            disabled={!edit}
          />
        </label>
        <br />
        <label>
          Date:
          <br />
          <input
            type="text"
            value={date}
            placeholder="MM/DD/YYYY"
            onChange={(e) => setDate(e.target.value)} // Handle date changes
            style={{ width: "100%", marginBottom: "1rem" }}
            disabled={!edit}
          />
        </label>
        <br />
        <div className="file-wrapper" style={{ display: "flex", alignItems: "center" }}>
          <input
            className="hidden"
            type="file"
            ref={fileInputRef}
            accept="image/*,application/pdf,.pdf"
            onChange={handleImageUpload}
          />
          <input
            className={`button-new positive ${!edit ? "inactive" : ""}`}
            style={{
              marginLeft: "0px",
              width: "160px",
              marginBlock: "1rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            type="button"
            value={!isBusy ? "Upload File" : ""}
            disabled={!edit || isBusy}
            onClick={() => fileInputRef.current.click()}
          />
          {isBusy && (
            <div
              style={{
                position: "absolute",
                width: "20px",
                height: "20px",
                border: "2px solid transparent",
                borderTop: "2px solid #fff",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
                marginLeft: "68px",
              }}
            />
          )}
        </div>
        {/* <div style={{ flex: 1 }}>
          <h2>Live Preview</h2>
          {text && (
            <div
              dangerouslySetInnerHTML={{ __html: marked(text) }}
              style={{ border: "1px solid #ccc", padding: "1rem" }}
            />
          )}
        </div> */}
      </div>
    </div>
  );
};

export default Event;
